import {
  updateDocument,
  createDocument,
  getId,
  saveHasOneRelationship
} from 'services/firestore'

import { updateParentHasOneRelationship } from 'hooks'
import { Role } from 'models'
import { message } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import { useState } from 'react'
import { useTranslations } from 'contexts/Translation'

const useActionsRoleAdvancedForm = ({ initialData, form } = {}) => {
  // [COMPONENT_STATE_HOOKS]
  const [loading, setLoading] = useState(false)

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const history = useHistory()
  const params = useParams()

  const prepareValues = async (values = {}, additionalValues = {}) => {
    const roleId = initialData?.['role']?._id || getId('roles')
    const additionalReferences = { roleId }
    const preparedValues = {
      _id: roleId,
      ...additionalValues,
      name: values?.['role']?.['name'] ?? null,
      customerId: await saveHasOneRelationship(
        'customers',
        values['customerId'],
        additionalReferences
      )
    }
    if (params.applicationId)
      preparedValues['applicationId'] = params.applicationId
    return preparedValues
  }

  const saveForm = async (values, callback) => {
    try {
      // Prepare data to be saved
      const data = await prepareValues(values)
      // Updating parent references
      if (params.applicationId)
        await updateParentHasOneRelationship(
          params.applicationId,
          'applications',
          'roleId',
          data._id
        )
      // Save data
      if (initialData) {
        await updateDocument('roles', initialData.role?._id, data)
        message.success(t('Role successfully updated'))
      } else {
        await createDocument('roles', data, data._id)
        message.success(t('Role successfully created'))
      }
      // Final callback
      callback?.()
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      throw new Error(t('Something went wrong during data save'))
    }
  }

  const validateForm = (values) => {
    try {
      // Prepare data to be validated
      const validationData = {
        name: values?.['role']?.['name']
      }
      Role.validationSchema.validateSync(validationData)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      throw new Error(t('Role validation error: ') + t(error.message))
    }
  }

  const onFinish = async () => {
    if (loading) return // Avoid multiple calls

    try {
      setLoading(true)
      // Get form values
      const formValues = form.getFieldsValue()
      // Validate fields
      validateForm(formValues)
      // Final callback
      const callback = () => history.goBack()
      // Save data
      await saveForm(formValues, callback)
    } catch (error) {
      setLoading(false)
      message.error(error.message)
    }
  }

  const onReset = () => {
    form.resetFields()
    history.goBack()
  }

  return { onFinish, onReset, loading, saveForm, validateForm, prepareValues }
}

export default useActionsRoleAdvancedForm
